export const getNewGruserPortFlagName = section => {
  let newGruserPortFlagName;
  switch (section) {
    case 'home':
      newGruserPortFlagName = 'gruser_home';
      break;
    case 'about':
      newGruserPortFlagName = 'gruser_about';
      break;
    case 'backroom':
      newGruserPortFlagName = 'gruser_backroom';
      break;
    case 'posts':
      newGruserPortFlagName = 'gruser_posts';
      break;
    default:
      newGruserPortFlagName = 'gruser_flag_that_dont_exist';
  }
  return newGruserPortFlagName;
};

export const isReleasedGrusers = section =>
  [
    'shop',
    'posts',
    'gallery',
    'favourites',
    'private_collections',
    'subscriptions',
  ].includes(section);
